<template>
  <div class="logo" :class="{'logo-audience': $store.state.logo}">
    <div class="logo-wrapper" v-if="canShowCustomLogo()">
      <img :src="$store.state.logo.large" alt>
    </div>
    <div class="logo-wrapper" v-if="canShowAhaSlideLogo()">
      <aha-logo
        class="default-logo ahaslides-logo"
        viewBox="0 0 385 65"
        width="152"
        height="26"
      />
      <aha-logo
        class="white-logo text-base-0 ahaslides-logo"
        :use-default-color="false"
        viewBox="0 0 385 65"
        width="152"
        height="26"
      />
    </div>
  </div>
</template>
<script>
import Util from '@/util'

export default {
  props: ['homepage'],

  methods: {
    canShowAhaSlideLogo() {
      // If using whitelabel account, dont show AhaSlides logo
      if (Util.checkWhiteLabelDomain() || this.$store.state.presentation.planType === 'white-label') return false

      return this.homepage || (!this.$store.state.logo && !this.$store.state.presentation.notShowAhaSlidesLogo && !this.homepage)
    },
    canShowCustomLogo() {
      return !this.canShowAhaSlideLogo() && this.$store.state.logo !== null
    },
  },
}
</script>

<style lang="scss" scoped>
.logo {
  padding: 20px 10px;
  margin: 0 auto;
  img, .ahaslides-logo {
    max-width: 200px;
    width: auto;
    height: auto;
    display: block;
    margin: 0 auto;
    max-height: 100px;

    &.white-logo {
      display: none;
    }
  }
}

.logo-audience {
  img, .ahaslides-logo {
    max-width: 400px;
  }
}

@media (max-width: 812px) {
  .logo {
    img, .ahaslides-logo {
      max-width: 140px;
    }
  }
  .logo-audience {
    img, .ahaslides-logo {
      max-width: 320px;
    }
  }
}

@media (max-width: 340px) {
  .logo-audience {
    img, .ahaslides-logo {
      max-width: 100%;
    }
  }
}

</style>
